<template>
  <div class="associated-tickets-print col-xs-12">
    <div v-if="loaded" v-for="(surveyTaken, indx) in surveyTakenIds" :key="indx">
      <h5>Pesquisador: {{ surveys[surveyTaken][0].user.name }}</h5>
      <table>
        <thead>
        <th> Ord.</th>
        <th> UC</th>
        <th> Nome</th>
        <th> Endereço Completo</th>
        <th> Ponto de referência</th>
        <th> Contatos</th>
        <th> Apelido</th>
        </thead>
        <tbody>
        <tr v-for="(survey, index) in surveys[surveyTaken]" :key="index" :class="index % 2 === 0 ? 'bg-line' : ''">
          <td width="5%">{{ indx + 1 }}-{{ index + 1 }}</td>
          <td width="10%">{{ customers[survey.customer._id].uc ? customers[survey.customer._id].uc : ' ' }}</td>
          <td width="20%">{{ customers[survey.customer._id].holder ? customers[survey.customer._id].holder : ' ' }}</td>
          <td width="20%">{{ getAddress(customers[survey.customer._id]) }}</td>
          <td width="25%">{{ customers[survey.customer._id].address.complement ? customers[survey.customer._id].address.complement : ' ' }}</td>
          <td width="10%">{{ customers[survey.customer._id].phone1 ? customers[survey.customer._id].phone1 : ' ' }} - {{ customers[survey.customer._id].phone2 ? customers[survey.customer._id].phone2 : ' ' }}</td>
          <td width="10%">{{ customers[survey.customer._id].aka ? customers[survey.customer._id].aka : ' ' }}</td>
        </tr>
        </tbody>
      </table>
      <div v-if="indx < surveyTakenIds.length" class="page-break"></div>
    </div>
  </div>
</template>

<script>
  import Couchdb from 'src/services/Couchdb'

  export default {
    name: 'associated-tickets-print',

    data () {
      return {
        tickets: [],
        customers: {},
        surveys: {}
      }
    },

    computed: {
      eventId () {
        return this.$route.params.id
      },

      loaded () {
        return Object.keys(this.customers).length > 0 && Object.keys(this.tickets).length > 0
      },

      surveyTakenIds () {
        return Object.keys(this.surveys)
      }
    },

    methods: {
      fetchTickets () {
        Couchdb.connection('default')
          .view({
            ddoc: 'tickets-associated-by-event',
            view: 'tickets-associated-by-event',
            key: this.eventId
          })
          .then(response => {
            if (response.rows && response.rows[0]) {
              this.tickets = response.rows.map(item => item.value)
              this.fetchCustomers()
            }
          })
          .catch(err => console.log(err))
      },

      fetchCustomers () {
        Couchdb.connection('default')
          .view({
            ddoc: 'customers-by-id',
            view: 'customers-by-id',
            keys: this.tickets.map(item => item.customerId)
          })
          .then(res => {
            if (!res.rows) {
              return
            }
            this.customers = res.rows
              .map(item => item.value)
              .reduce((acc, curr, index) => {
                if (index === 0) {
                  acc = {}
                }
                acc[curr._id] = curr
                return acc
              }, {})
            this.fetchSurveys()
          })
      },

      fetchSurveys () {
        Couchdb.connection('surveys')
          .view({
            ddoc: 'surveys-by-event',
            view: 'surveys-by-event',
            key: this.eventId
          })
          .then(res => {
            if (!res.rows) {
              this.failed = true
            }
            this.surveys = res.rows.map(item => {
              return item.value
            })
              .reduce((acc, curr, indx) => {
                if (indx === 0) {
                  acc = {}
                }
                if (!acc.hasOwnProperty(curr.user._id)) {
                  acc[curr.user._id] = []
                }
                acc[curr.user._id].push(curr)
                return acc
              }, {})
          })
          .catch(err => console.log(err))
      },

      getAddress (customer) {
        let addressText = `${customer.address.street}, ${customer.address.number}, ${customer.address.neighborhood}, ${customer.address.zip}`
        addressText = customer.address.zip ? addressText + `, ${customer.address.zip}` : addressText
        return addressText
      }
    },

    mounted () {
      if (this.eventId) {
        this.fetchTickets()
      }
    }
  }
</script>

<style scoped>
  table {
    font-size: 8px;
    width: 100%;
  }

  td {
    padding-top: 1em;
    padding-bottom: 1em;
  }

  .bg-line {
    background-color: #EEE;
  }

  @media print {
    .page-break {
      page-break-after: always;
    }
  }

  strong {
    font-weight: bolder;
  }

  @page {
    size: A4 portrait;
    margin: 1em;  /* this affects the margin in the printer settings */
  }
</style>



// WEBPACK FOOTER //
// src/pages/Surveys/AssociatedTicketsPrint.vue